import cuid from "cuid";
import { defaults, get, keyBy, map } from "lodash";
import { CONTACT_POINT_SYSTEM } from "utils/constants";
import Template from "../Template";
import View from "./View";

const AdherentInfoLmf = ({ project, currentStatus, onNext, onBack }) => {
  const telecoms = defaults(keyBy(get(project, "contact.telecoms"), "system"), {
    [CONTACT_POINT_SYSTEM.ZIP_CODE]: { value: null },
  });

  const next = ({ contact, contract }) => {
    const mappedTelecoms = map(get(contact, "telecoms"), (item, key) =>
      defaults(item, { id: cuid(), system: key }),
    );
    onNext({
      payload: {
        visible: true,
        contact: {
          ...contact,
          telecoms: mappedTelecoms,
        },
        contract,
      },
    });
  };

  const initialValues = {
    contact: {
      ...get(project, "contact", {}),
      telecoms,
      fields: {
        ...get(project, "contact.fields", {}),
        acceptDigital: get(project, "contact.fields.acceptDigital", false),
        acceptContact: get(project, "contact.fields.acceptContact", false),
      },
    },
    contract: get(project, "contract"),
  };

  return (
    <Template
      progress={currentStatus.progress}
      onBack={onBack}
      project={project}
      View={
        <View
          onNext={next}
          initialValues={initialValues}
          fields={get(project, "fields", {})}
          locked={project.locked}
          onBack={onBack}
        />
      }
    />
  );
};

export default AdherentInfoLmf;
